exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-nabizim-contentful-nabizim-slug-tsx": () => import("./../../../src/pages/nabizim/{ContentfulNabizim.slug}.tsx" /* webpackChunkName: "component---src-pages-nabizim-contentful-nabizim-slug-tsx" */)
}

